import { DOMPurify } from '@/utils';
import React, { useEffect } from 'react';

type WistiaPlayerProps = {
    videoId: string;
    wrapper: string;
};

export const WistiaPlayer = ({ videoId, wrapper }: WistiaPlayerProps) => {
    useEffect(() => {
        initializeWistiaEmbed(videoId, wrapper);

        return () => {
            const container = document.getElementById(wrapper);

            if (container) {
                container.innerHTML = '';
            }
        };
    }, [videoId, wrapper]);

    const initializeWistiaEmbed = (videoId: string, wrapper: string): void => {
        const container = document.getElementById(wrapper);
        if (!container) return;

        const script1 = document.createElement('script');
        script1.src = DOMPurify.sanitize(`https://fast.wistia.com/embed/medias/${videoId}.jsonp`);
        script1.async = true;

        const script2 = document.createElement('script');
        script2.src = DOMPurify.sanitize('https://fast.wistia.com/assets/external/E-v1.js');
        script2.async = true;

        const div = document.createElement('div');
        const sanitizedHtml = DOMPurify.sanitize(`<div class="wistia_responsive_padding" 
                            style="padding:56.25% 0 0 0;position:relative;">
                            <div class="wistia_responsive_wrapper" 
                                style="height:100%;left:0;position:absolute;top:0;width:100%;">
                                    <div class="wistia_embed wistia_async_${videoId} 
                                        seo=false 
                                        videoFoam=true" 
                                        style="height:100%;position:relative;width:100%"
                                    >
                                        <div class="wistia_swatch" 
                                            style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"
                                        >
                                            <img src="https://fast.wistia.com/embed/medias/${videoId}/swatch" 
                                                style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" 
                                                alt="" 
                                                aria-hidden="true" 
                                                onload="this.parentNode.style.opacity=1;" 
                                            />
                                        </div>
                                    </div>
                                </div>
                        </div>`);

        div.innerHTML = sanitizedHtml;
        container.appendChild(script1);
        container.appendChild(script2);
        container.appendChild(div);
    };

    return <div id={wrapper}></div>;
};
